var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.loggedin === true)?_c('div',[_c('ContractWizard',{attrs:{"username":_vm.username}})],1):_c('div',[_vm._v("\n    You need to log in\n    "),_c('v-btn',{on:{"click":_vm.loginRedirect}},[_vm._v("Log In")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }